import { Routes } from '@angular/router';
import { LandingComponent } from './Components/landing/landing.component';
import { DashboardComponent } from './Components/dashboard/dashboard.component';
import { LoginComponent } from './Components/login/login.component';
import { loginGuard } from './core/guards/login.guard';
import { MsalGuard } from '@azure/msal-angular';
import { PageNotFoundComponent } from './Components/page-not-found/page-not-found.component';
import { preferenceResolver } from './core/resolver/preference.resolver';
import { unsavedChangesGuard } from './core/guards/unsaved-changes.guard';

export const routes: Routes = [
    {
        path: '',
        redirectTo: '/login',
        pathMatch: 'full'
    },
    {
        path: 'login',
        component: LoginComponent,
        canActivate: [loginGuard]
    },
    {
        path: 'dashboard',
        component: LandingComponent,
        canActivate: [MsalGuard],
        children: [
            {
                path: '',
                component: DashboardComponent,
                canDeactivate: [unsavedChangesGuard],
                resolve: {
                    preferences: preferenceResolver
                }
            }
        ]
    },
    {
        // Standalone playground for the numeric mask directive — unguarded for easy testing.
        path: 'numeric-playground',
        loadComponent: () =>
            import('./shared/numeric/examples/numeric-form.example')
                .then(m => m.NumericFormExampleComponent),
    },
    {
        path: '**',
        component: PageNotFoundComponent
    }
];
